var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPlayerPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002A69",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2M8.964 8.65l-.053.5-.03.333-.042.6-.024.46-.018.505-.01.549v.578l.01.549.018.506.024.46.042.6.071.73.013.102a1.192 1.192 0 0 0 1.651.954l.456-.202.651-.309.39-.196.43-.224.466-.253.498-.282.493-.29.231-.14.43-.27.388-.25.342-.229.653-.46.177-.131a1.192 1.192 0 0 0-.001-1.908l-.406-.297-.275-.193-.32-.218-.565-.368-.428-.268-.47-.282-.499-.288-.478-.265-.447-.238-.41-.21-.54-.263-.439-.202-.23-.102a16.814 16.814 0 0 0-.095-.04 1.192 1.192 0 0 0-1.654.952"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlayerPlay);
export default __webpack_public_path__ + "static/media/Audio_player_play.ccf94eabbe143d3680fe7bdd1d2faf06.svg";
export { ForwardRef as ReactComponent };